import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import InfoRounded from '@material-ui/icons/InfoRounded';
import ClearRounded from '@material-ui/icons/ClearRounded';
import ListboxComponent from '../ListboxComponent';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import PropTypes from 'prop-types';
import uniqBy from 'lodash/uniqBy';
import { noop } from '../propTypes';
import FormInput from '../FormInput';
import './styles.scss';

// icon being showed beside auto-complete single row before selection
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
// icon being showed beside auto-complete single row after selection
const checkedIcon = <CheckBoxIcon fontSize="small" color="primary" />;
// close icon for the Tag/Chip
const closeRoundedIcon = <ClearRoundedIcon fontSize="small" />;

function TaggedFieldWithAutoComplete({
    options,
    placeholder,
    bootstrapIcon,
    title,
    onSelect,
    rightBtnText,
    showRightBtn,
    disabled,
    onRightBtnClick,
    defaultValue,
    id,
    allowCommaSeparated,
    stylesIcon,
}) {
    const [value, setValue] = React.useState(defaultValue ? defaultValue : []);
    const [error, setError] = React.useState(null);
    const [inputValue, setInputValue] = React.useState('');
    React.useEffect(() => {
        setValue(defaultValue ? defaultValue : []);
    }, [defaultValue]);

    return (
        <>
            <FormInput
                title={title}
                bootstrapIcon={bootstrapIcon}
                stylesIcon={stylesIcon}
            >
                <Autocomplete
                    multiple
                    id={id}
                    options={options}
                    disabled={disabled}
                    disableCloseOnSelect
                    value={value}
                    inputValue={inputValue}
                    ListboxComponent={ListboxComponent}
                    onChange={(event, selected) => {
                        Object.keys(event); //this will give you the selected value dictionary (source)
                        onSelect(selected); //this will give you the selected value dictionary (source)
                    }}
                    onInputChange={(event, newInputValue, reason) => {
                        if (event && event.type === 'blur') {
                            setInputValue(newInputValue);
                            return;
                        }
                        // This logic is only for user selection in reports
                        if (
                            allowCommaSeparated &&
                            newInputValue.indexOf(',') > -1
                        ) {
                            setError(null);
                            let newSelectedValue = [];
                            let errroneusState = [];
                            // Split all the usernames searated with commas
                            let splitted = newInputValue.split(',');
                            // remove last empty username because it will always be empty
                            if (splitted[splitted.length - 1] === '')
                                splitted.pop();
                            splitted
                                // trimming all the values to remove extra spaces in username
                                .map((item) => item.trim())
                                // filter out all the users with exactly matching user names
                                .forEach((item) => {
                                    const val = options.find((i) => {
                                        // extracting username because in our case usernames is casted as abc [abc-123]
                                        // deep cloning the title
                                        let title = [...i.title];
                                        if (i.title.includes('[')) {
                                            title = [...i.title]
                                                .join('')
                                                .split('[');
                                            // remove first part example "abc " after split we have ["abc ", "abc-123]"]
                                            title.shift();
                                            // spliting it to remove last square brancket
                                            title = title.join('').split(']');
                                            // after split we have ["abc-123", ""] remove the last item
                                            title.pop();
                                        }
                                        title = title.join('');
                                        // at this point we have exact user name "abc-123"
                                        // that will be deep compared with user entered value
                                        return i.id === item || title === item;
                                    });
                                    if (val) {
                                        newSelectedValue.push(val);
                                    } else {
                                        // keep all the usernames that are not valid or not available in this
                                        errroneusState.push(item);
                                    }
                                });
                            if (errroneusState.length) {
                                setError(errroneusState.join(', '));
                            }
                            // using uniqby to make sure we dont have duplicated users as selected
                            if (
                                uniqBy(newSelectedValue.concat(...value), 'id')
                                    .length
                            ) {
                                onSelect(
                                    uniqBy(
                                        newSelectedValue.concat(...value),
                                        'id',
                                    ),
                                );
                            }
                            if (
                                reason === 'input' &&
                                newInputValue.trim().endsWith(',')
                            ) {
                                setInputValue('');
                            } else {
                                setInputValue(
                                    reason === 'reset'
                                        ? inputValue
                                        : newInputValue,
                                );
                            }
                        } else {
                            setInputValue(
                                reason === 'reset' ? inputValue : newInputValue,
                            );
                        }
                    }}
                    getOptionLabel={(option) => option.title}
                    renderOption={(option, { selected }) => {
                        const isSelected =
                            (options &&
                                (defaultValue || []).find(
                                    (item) => item.id == option.id,
                                )) ||
                            selected;
                        return (
                            <>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    className="single-tag"
                                    checked={selected || isSelected}
                                />
                                {option.title}
                                {option.isGlobal && (
                                    <span
                                        style={{
                                            backgroundColor: '#027aff',
                                            color: 'white',
                                            marginLeft: 5,
                                        }}
                                        className="badge badge-secondary"
                                    >
                                        Featured
                                    </span>
                                )}
                            </>
                        );
                    }}
                    renderInput={(params) => {
                        return (
                            <>
                                <TextField
                                    variant="outlined"
                                    placeholder={placeholder}
                                    fullWidth
                                    className="with-sub-btn"
                                    {...params}
                                />
                                {showRightBtn && (
                                    <button
                                        onClick={onRightBtnClick}
                                        className="btn sub-btn-right"
                                    >
                                        <span className="icon-latest-plus"></span>
                                        {rightBtnText}
                                    </button>
                                )}
                            </>
                        );
                    }}
                    ChipProps={{
                        deleteIcon: closeRoundedIcon,
                    }}
                />
            </FormInput>
            {error && (
                <span
                    style={{
                        position: 'absolute',
                        right: 120,
                        top: 0,
                        color: 'red',
                        fontSize: 12,
                    }}
                >
                    One or more of the names provided does not match any entry.
                    <Tooltip title={`Invalide users are: ${error}`}>
                        <IconButton style={{ padding: 0 }}>
                            <InfoRounded
                                color="error"
                                style={{ fontSize: 12 }}
                            />
                        </IconButton>
                    </Tooltip>
                    <IconButton
                        style={{ padding: 0 }}
                        onClick={() => setError(null)}
                    >
                        <ClearRounded style={{ fontSize: 12 }} />
                    </IconButton>
                </span>
            )}
        </>
    );
}

TaggedFieldWithAutoComplete.propTypes = {
    options: PropTypes.array,
    placeholder: PropTypes.string,
    bootstrapIcon: PropTypes.string,
    title: PropTypes.string,
    onSelect: PropTypes.func,
    id: PropTypes.string,
    rightBtnText: PropTypes.string,
    showRightBtn: PropTypes.bool,
    onRightBtnClick: PropTypes.func,
    defaultValue: PropTypes.array,
    disabled: PropTypes.bool,
    stylesIcon: PropTypes.object,
    allowCommaSeparated: PropTypes.bool,
};

TaggedFieldWithAutoComplete.defaultProps = {
    value: null,
    placeholder: 'Favorites',
    bootstrapIcon: 'icon-flag',
    title: 'Challenges',
    onSelect: noop,
    id: '12',
    allowCommaSeparated: false,
    defaultValue: [],
    rightBtnText: 'Compare',
    showRightBtn: false,
    onRightBtnClick: noop,
    disabled: false,
};

export default TaggedFieldWithAutoComplete;
